import ObliqueSpacer from "./ObliqueSpacer";
import DefaultSpacer from "./DefaultSpacer";
import MenuBar from "./MenuBar";
import { FC } from "react";

import styles from "./index.module.scss";

interface IProps {
  type?: string;
  color?: any[any];
  textColor?: any[any];
  children: any;
  route?: string;
  display?: string;
  layout: string;
}

const DesignToken: FC<IProps> = ({
  children,
  color,
  textColor: text,
  route,
  display,
  layout,
  type,
}) => {
  function MouseOver(event: any) {
    event.target.style.background = color.hex;
    event.target.style.transition = ".3s";
    event.target.style.color = "white";
  }
  function MouseOut(event: any) {
    event.target.style.background = "";
    event.target.style.color = color.hex;
  }

  switch (layout) {
    case "borderFull":
      return (
        <div
          onMouseOver={MouseOver}
          onMouseOut={MouseOut}
          className={`${styles.borderFull}`}
          style={{ borderColor: color.hex, color: color.hex }}
        >
          {children}
        </div>
      );
      break;
    case "oblique":
      return (
        <>
          {display === "ageGate" ? (
            <>
              {route === "/age-gate" ? (
                <>
                  <ObliqueSpacer
                    type={layout}
                    color={color}
                    textColor={text}
                    children={children}
                    route={route}
                  />
                </>
              ) : (
                <>
                  <DefaultSpacer
                    type={layout}
                    color={color}
                    textColor={text}
                    children={children}
                    route={route}
                  />
                </>
              )}
            </>
          ) : (
            <ObliqueSpacer
              type={layout}
              color={color}
              textColor={text}
              children={children}
              route={route}
            />
          )}
        </>
      );
    case "menuBar":
      return (
        <MenuBar type={type} color={color}>
          {children}
        </MenuBar>
      );
      break;
    default:
      return <></>;
      break;
  }
};

export default DesignToken;
